module.exports = __webpack_public_path__ + "media/images/logo/Logo(H)_WhiteOL-4e6ca316fead804e34384050451ee07c.png";